import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Avatar from "@mui/material/Avatar";
import { CardHeader } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { WHITE } from "../colors";
import Banner from "../components/banners/Banner";

export default function CustomerListContainer(props) {
  const { userClicked } = props;
  return (
    <div>
      <TableContainer component={Paper} sx={{ maxHeight: 480 ,opacity:0.9 ,borderRadius:4 }}>
        <Table
          sx={{
            minWidth: 650,
            backgroundColor: WHITE,
            maxHeight: 600,
          }}
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              {/* <TableCell padding="checkbox">
                <Checkbox color="primary" checked={false} />
              </TableCell> */}
              <TableCell></TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Ref No</TableCell>
              <TableCell align="center">ID Number</TableCell>
              <TableCell align="center">Passpot Number</TableCell>
              <TableCell align="center">Phone</TableCell>
              <TableCell align="center">Country</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.customers?.length > 0 &&
              props?.customers?.map((row) => (
                <TableRow
                  hover
                  onClick={() => userClicked(row)}
                  key={row.id}
                  sx={{
                    "&:last-child td, &:last-child th": {
                      border: 0,
                    },
                  }}
                >
                  {/* <TableCell padding="checkbox">
                  <Checkbox color="primary" checked={false} />
                </TableCell> */}
                  <TableCell component="th" scope="row">
                    <Avatar
                      alt="Remy Sharp"
                      src={
                        row.passport_size_image || "/static/images/avatar/1.jpg"
                      }
                    />
                  </TableCell>
                  <TableCell >{row.full_name}</TableCell>
                  <TableCell >{row.reg_number}</TableCell>
                  <TableCell align="center">{row.nic}</TableCell>
                  <TableCell align="center">{row.passport}</TableCell>
                  <TableCell align="center">{row.phone_mobile}</TableCell>
                  <TableCell align="center">{row.des_country}</TableCell>
                  <TableCell align="center">{row.status}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      {props?.customers?.length === 0 && (
        <Banner message="No customers found" />
      )}
    </div>
  );
}
